import React from 'react';
import { Users, Gamepad2, Trophy } from 'lucide-react';
import { Button } from '../components/ui/button';

const Community = () => {
  return (
    <section className="bg-[#121212] py-20">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-[48px] font-semibold leading-[1.1] tracking-[-0.02em] text-white mb-6">
              Join Our Thriving Community
            </h2>
            <p className="text-[20px] font-medium leading-[1.5] text-[rgba(255,255,255,0.85)] mb-10">
              Connect with thousands of farmers, share strategies, and compete in global tournaments
            </p>

            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#00FFD1] flex items-center justify-center flex-shrink-0">
                  <Users className="w-7 h-7 text-black" />
                </div>
                <div>
                  <h3 className="text-[24px] font-semibold text-white mb-2">
                    Active Discord Community
                  </h3>
                  <p className="text-[18px] text-[rgba(255,255,255,0.85)]">
                    Join 25,000+ players discussing strategies and updates
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#00FFD1] flex items-center justify-center flex-shrink-0">
                  <Gamepad2 className="w-7 h-7 text-black" />
                </div>
                <div>
                  <h3 className="text-[24px] font-semibold text-white mb-2">
                    Weekly Events
                  </h3>
                  <p className="text-[18px] text-[rgba(255,255,255,0.85)]">
                    Participate in challenges and earn exclusive rewards
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#00FFD1] flex items-center justify-center flex-shrink-0">
                  <Trophy className="w-7 h-7 text-black" />
                </div>
                <div>
                  <h3 className="text-[24px] font-semibold text-white mb-2">
                    Competitive Tournaments
                  </h3>
                  <p className="text-[18px] text-[rgba(255,255,255,0.85)]">
                    Compete for prize pools worth thousands in PIO tokens
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <Button className="bg-[#00FFD1] text-black hover:bg-[rgba(0,255,209,0.8)] border-0 rounded-none h-14 px-8 text-lg font-medium">
                Join Discord
              </Button>
              <Button className="bg-[rgba(255,255,255,0.1)] text-white hover:bg-white hover:text-black border-0 rounded-none h-14 px-8 text-lg font-medium">
                Follow on Twitter
              </Button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative h-[600px] overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1725272532764-183d164c722b"
              alt="Gaming Community"
              className="w-full h-full object-cover border border-[rgba(255,255,255,0.25)]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;
